export default __webpack_public_path__ + "static/media/employees-background.79dd01e9.svg";